namespace $.$$ {

	$mol_style_define( $eve_switch_labelled, {
		
		cursor: 'pointer',
		userSelect: 'none',

		Label: {
			cursor: 'pointer',
		},
		
	} )
	
}

